import Link from "next/link";
import type { ReactNode } from "react";
import { useButtonClasses } from "../Button/Button";
import styles from "./ButtonLink.module.css";

interface Props {
  primary?: boolean;
  disabled?: boolean;
  children: ReactNode;
  href: string;
}

export function ButtonLink(props: Props): React.ReactNode {
  const classNames = `${useButtonClasses(props)} ${styles.button}`;

  if (props.disabled) {
    return <span className={classNames}>{props.children}</span>;
  }

  return (
    <Link href={props.href} className={classNames} prefetch={false}>
      {props.children}
    </Link>
  );
}
